import Smartphones from 'Todo/views/TodoIntegrationsView/containers/Smartphones'
import Tablets from 'Todo/views/TodoIntegrationsView/containers/Tablets'

import { getCurrentDeviceView } from 'shared/helpers/utils'

const TodoIntegrationsView = getCurrentDeviceView(Smartphones, Tablets)

export default TodoIntegrationsView
